module.exports = __webpack_public_path__ + "static/media/logo.ea05c37f.png";